import { Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Dispatch, SetStateAction } from 'react';
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export function PaymentLogsModal({ open, onClose, setOpen }: ModalProps) {

  const rows = [
    { date: "24 Jul 2025", amount: "₹499", method: "Stripe", status: "Success", className: "c_success" },
    { date: "24 Jun 2025", amount: "₹499", method: "Stripe", status: "Success", className: "c_success" },
    { date: "24 May 2025", amount: "₹499", method: "Stripe", status: "Failed", className: "c_danger" },
  ];
  
  return (
    <Modal className="modal paymentLog_modal" open={open} onClose={onClose}>
      <div className="modal-dialog lg">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Payment Logs</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <TableContainer className="table_container">
            <Table className="payment_log_table">
              <TableHead>
                <TableRow hover>
                  <TableCell>Date</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Method</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow hover key={index}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.amount}</TableCell>
                    <TableCell>{row.method}</TableCell>
                    <TableCell>
                      <span className={`status_btn ${row.className}`}>{row.status}</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Modal>
  )
}